import React, { useEffect } from "react";
import "./ComingSoonModal.css";
import { IoClose } from "react-icons/io5";
import ComingSoonImg from "../../../Assets/ComingSoon/comingsoon.png";

const ComingSoonModal = ({ isOpen, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => (document.body.style.overflow = "unset");
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="coming-soon-overlay" onClick={onClose}>
            <div className="coming-soon-card" onClick={(e) => e.stopPropagation()}>
                <button className="coming-soon-close" onClick={onClose}>
                    <IoClose />
                </button>
                <img src={ComingSoonImg} alt="Coming Soon" className="coming-soon-img" />
            </div>
        </div>
    );
};

export default ComingSoonModal;
